// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#bfcbd9","menuActiveText":"#409EFF","subMenuActiveText":"#f4f4f5","menuBg":"#304156","menuHover":"#263445","subMenuBg":"#1f2d3d","subMenuHover":"#001528","sideBarWidth":"210px"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/variables.scss
// module id = syC2
// module chunks = 9